import IconButton from "@ui-kit/form/IconButton/IconButton.web";
import Icon from "@ui-kit/icons/Icon.web";
import Flex, { type FlexProps } from "@ui-kit/layout/Flex/Flex.web";
import React from "react";
import SwiperCore, { A11y, Mousewheel, Navigation, Virtual } from "swiper";
import { Swiper as BaseSwiper, SwiperSlide } from "swiper/react";
import "@shared/styles/swiper-overrides.css";

SwiperCore.use([Navigation, Mousewheel, A11y, Virtual]);

const Swiper = ({
  children,
  heading,
  swiperContainerProps,
  slidesOffsetBefore,
}: {
  children: React.ReactNode;
  heading?: React.ReactNode;
  swiperContainerProps?: FlexProps;
  slidesOffsetBefore?: number;
}) => {
  const uniqueId = React.useId().replace(/:/g, "-");
  const prevClass = `swiper-prev-${uniqueId}`;
  const nextClass = `swiper-next-${uniqueId}`;

  const slidesOffsetBeforeValue = slidesOffsetBefore ?? 0;

  return (
    <Flex
      height="auto"
      alignItems="center"
      width="100%"
      zIndex={0}
      className="swiper-full-width swiper-themed-nav swiper-add-ons-checkout"
      {...swiperContainerProps}
    >
      <Flex direction="column" w="100%" gap="md">
        <Flex
          direction="row"
          justifyContent={heading ? "space-between" : "flex-end"}
          alignItems="center"
          gap="2xs"
        >
          {heading}
          <Flex gap="2xs" display={{ base: "none", md: "flex" }}>
            <IconButton.Primitive
              aria-label="Previous products"
              variant="unstyled"
              className={prevClass}
              bg="transparent"
              _focus={{ boxShadow: "none" }}
            >
              <Icon.ChevronLeftRounded color="gray.700" />
            </IconButton.Primitive>

            <IconButton.Primitive
              aria-label="Next products"
              variant="unstyled"
              className={nextClass}
              bg="transparent"
              _focus={{ boxShadow: "none" }}
            >
              <Icon.ChevronRightRounded color="gray.700" />
            </IconButton.Primitive>
          </Flex>
        </Flex>
        <BaseSwiper
          // force swiper to re-render when slidesOffsetBefore changes
          key={slidesOffsetBeforeValue}
          freeMode
          mousewheel={{
            forceToAxis: true, // Restricts scrolling to a single axis
            sensitivity: 1, // Sets the sensitivity of mouse wheel scrolling
          }}
          navigation={{
            prevEl: `.${prevClass}`,
            nextEl: `.${nextClass}`,
          }}
          spaceBetween={20}
          slidesOffsetAfter={20}
          slidesOffsetBefore={slidesOffsetBeforeValue}
          slidesPerView="auto"
        >
          {children}
        </BaseSwiper>
      </Flex>
    </Flex>
  );
};

export default Swiper;

Swiper.Slide = SwiperSlide;
